export { useApplySectionBackground } from './use-apply-section-background';
